type Bucket = {
  id: string;
  path: string;
  displayPath: string;
  name: string;
  parent: any;
  scanned: boolean;
  open: boolean;
  error: any | null;
  level: number;
  children: Array<any>;
};
export function buildSelectedBucket(path: string, display_path: string): Bucket {
  if (path) {
    const id = path;
    const lastSlashIndex = id.lastIndexOf('/');
    const name = id.substr(lastSlashIndex + 1);
    const parent = lastSlashIndex > -1 ? id.substr(0, lastSlashIndex) : null;
    const numSlashes = (id.match(/\//g) || []).length;
    const level = numSlashes + 1;

    return {
      id,
      path: path,
      displayPath: display_path || path,
      name,
      parent,
      scanned: false,
      open: false,
      error: null,
      level,
      children: [],
    };
  } else {
    console.error('You must provide a valid path');
  }
}
